import React from "react";
import { Card, CardBody, CardHeader, Table } from "reactstrap";

const DEFAULT_COLS = [
  { id:"time",        label:"Time",        field:"time",        visible:true },
  { id:"temperature", label:"Temperature", field:"temperature", visible:true },
  { id:"message",     label:"Message",     field:"message",     visible:true },
];

const AlarmTable = ({ alarmList, columnConfig }) => {
  const cols = (columnConfig || DEFAULT_COLS).filter(c => c.visible !== false);
  return (
    <Card className="h-100 mb-0">
      <CardHeader className="py-2"><h5 className="mb-0 font-size-14">Temperature Alarms</h5></CardHeader>
      <CardBody style={{ overflowY:"auto", padding:0, height:"calc(100% - 48px)" }}>
        <Table bordered hover className="mb-0" style={{ fontSize:13 }}>
          <thead className="table-light" style={{ position:"sticky", top:0, zIndex:1 }}>
            <tr>{cols.map(c=><th key={c.id}>{c.label}</th>)}</tr>
          </thead>
          <tbody>
            {alarmList.length > 0
              ? alarmList.map((alarm, i) => (
                <tr key={i}>{cols.map(c=><td key={c.id}>{alarm[c.field]??'—'}{c.field==="temperature"?" °C":""}</td>)}</tr>
              ))
              : <tr><td colSpan={cols.length} className="text-center text-muted py-4">No alarms found</td></tr>
            }
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default AlarmTable;
